import * as React from 'react';
import { Icon } from '../Icon/Icon';
import { CameraMenuGroup } from './CameraMenuGroup';
import { Camera, CameraGroup, type ICameraMenuProps, type ICameraMenuState, MenuItem } from './Cameras.types';

export class CameraMenu extends React.Component<ICameraMenuProps, ICameraMenuState> {
    private roads: CameraGroup[];
    private all: Camera[];

    constructor(props: ICameraMenuProps) {
        super(props);
        this.all = this.setCurrent(props.cameras);
        this.roads = this.groupBy(this.all, 'road', (_key, items) => items[0].roadUrl);

        let openItem = 'Alla kameror';

        if (props.currentRoad) {
            openItem = 'Kameraområde';
        }

        const menuItems: MenuItem[] = [
            new MenuItem('icon-camera', 'Alla kameror', null, this.props.allCamerasPageUrl),
            new MenuItem('icon-star', 'Mina kameror', null, this.props.favoriteCamerasPageUrl),
            new MenuItem('icon-camera-area', 'Kameraområde', this.roads),
        ];

        this.state = { openItem, menuItems };
    }

    public render(): JSX.Element {
        const classFilter = this.state.mobileopen ? 'collapse d-md-block show' : 'd-md-block collapse';
        const mobileButtonText = this.state.mobileopen ? 'Dölj kameraval' : 'Visa kameraval';
        const mobileButtonClass = this.state.mobileopen ? 'btn btn-dark btn-filter d-md-none' : 'btn btn-dark btn-filter d-md-none show-arrow-down';
        return (
            <div className="side-navigation">
                <button
                    type="button"
                    className={mobileButtonClass}
                    aria-expanded="false"
                    aria-controls="choices"
                    onClick={this.togglemobileMenu.bind(this)}
                >
                    {mobileButtonText}
                </button>
                <div id="choices" className={classFilter}>
                    <nav>
                        <ul className="side-navigation__list">{this.state.menuItems.map(this.renderMenuItem.bind(this))}</ul>
                    </nav>
                </div>
            </div>
        );
    }

    private getFavoriteCameras(): number[] {
        const result: number[] = [];
        const name = 'MyCameraPages' + this.props.currentRegion.toUpperCase();

        const value = '; ' + document.cookie;
        const parts = value.split('; ' + name + '=');
        if (parts.length === 2) {
            const ids = decodeURIComponent(parts.pop().split(';').shift()).split(';');

            for (let i = 0; i < ids.length; i++) {
                const id = Number(ids[i]);

                if (!isNaN(id) && id !== 0) {
                    result.push(id);
                }
            }
        }

        return result;
    }

    private setFavorite(cameras: Camera[]): Camera[] {
        const favorites = this.getFavoriteCameras();

        const result: Camera[] = cameras.map((c) => {
            c.isFavorite = favorites.indexOf(c.pageId) > -1;

            return c;
        });

        return result;
    }

    private setCurrent(cameras: Camera[]): Camera[] {
        const current = this.props.currentCameraPageId;

        const result: Camera[] = cameras.map((c) => {
            c.isCurrent = c.pageId === current;

            return c;
        });

        return result;
    }

    private groupBy(cameras: Camera[], key: string, urlFn: (key: string, items: Camera[]) => string): CameraGroup[] {
        const grouped = cameras.reduce((tempGroup, camera) => {
            (tempGroup[camera[key]] = tempGroup[camera[key]] || []).push(camera);
            return tempGroup;
        }, {});

        const result: CameraGroup[] = [];

        for (const group in grouped) {
            if (!Object.hasOwn(grouped, group)) {
                continue;
            }
            const items: Camera[] = grouped[group];
            let name: string = group;
            let hidden = false;

            if (group === 'undefined') {
                name = 'Ospecificerad';
                hidden = true;
            }

            const url: string = urlFn(name, items);

            result.push(new CameraGroup(name, key, items, url, hidden));
        }

        return result;
    }

    private setOpenItem = (event) => {
        event.preventDefault();

        const name = event.currentTarget.dataset.name;

        if (this.state.openItem === name) {
            this.setState({ openItem: '' });
        } else {
            this.setState({ openItem: name });
        }
    };

    private togglemobileMenu() {
        this.setState({ mobileopen: !this.state.mobileopen });
    }

    private renderMenuItem(item: MenuItem, index: number): JSX.Element {
        let toogleDivClassName = 'side-navigation-submenu collapse';
        let groupItemArrowDown = '';
        let carretClassName = 'icon-animated icon-up-open icon-rotate-180 camera-page__arrow-down';
        if (this.state.openItem === item.name) {
            groupItemArrowDown = 'groupitem-wrapper__group-item-arrow-down';
            toogleDivClassName += ' show';
            carretClassName = 'icon-animated camera-page__arrow-up icon-up-open';
        }

        const renderLinkContent = () => {
            return (
                <div className="d-flex align-items-center camera-page__groupitem">
                    <Icon symbol={item.icon} className="side-navigation__item-icon" />
                    <span className="camera-page__itemName">{item.name}</span>
                </div>
            );
        };

        const renderSpanContent = () => {
            return (
                <a
                    href="#"
                    data-name={item.name}
                    onClick={this.setOpenItem}
                    className={'d-flex align-items-center justify-content-between side-navigation__link camera-page__groupitem' + groupItemArrowDown}
                >
                    <div className="d-flex align-items-center">
                        <Icon symbol={item.icon} className="side-navigation__item-icon" />
                        <span className="camera-page__itemName">{item.name}</span>
                    </div>
                    <span className={carretClassName} title={this.state.openItem === item.name ? 'Markör öppen' : 'Markör stängd'} />
                </a>
            );
        };

        return (
            <li key={index} className="side-navigation__item">
                {item.url !== undefined ? (
                    <a className="side-navigation__link" href={item.url}>
                        {renderLinkContent.apply(this)}
                    </a>
                ) : (
                    renderSpanContent()
                )}
                {item.url === undefined ? (
                    <div className={toogleDivClassName}>
                        <CameraMenuGroup
                            currentArea={this.props.currentArea}
                            currentRoad={this.props.currentRoad}
                            groups={item.cameraGroups}
                            currentRegion={this.props.currentRegion}
                        />
                    </div>
                ) : null}
            </li>
        );
    }
}
